import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

const renderTextSegment = (segment, index) => {
    if (typeof segment === 'string') return segment;
    return segment.bold ? <strong key={index}>{segment.text}</strong> : segment.text;
};

const renderDetail = (detail) => {
    if (typeof detail === 'string') {
        return <p className="card-text">{detail}</p>;
    }

    if (Array.isArray(detail)) {
        return (
            <p className="card-text">
                {detail.map((segment, i) => renderTextSegment(segment, i))}
            </p>
        );
    }

    return (
        <p className="card-text">
            {detail.bold ? <strong>{detail.text}</strong> : detail.text}
        </p>
    );
};

const TeamCard = ({ id, name, image, details }) => {
    const handleClick = () => window.scrollTo(0, 0);

    return (
        <div className="experts-detail col-md-4">
            <div className="card" style={{ width: "18rem" }}>
                <NavLink to={`/expert/${id}`} onClick={handleClick}>
                    <img
                        src={image}
                        alt={`Portrait of ${name}`}
                        className="card-img-top"
                    />
                </NavLink>
                <div className="card-body">
                    <h5 className="text-start fw-bold mb-3">
                        <NavLink to={`/expert/${id}`} onClick={handleClick}>
                            {name}
                        </NavLink>
                    </h5>
                    <ul>
                        {details.map((detail, index) => (
                            <li key={index}>
                                {renderDetail(detail, index)}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

TeamCard.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    details: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                text: PropTypes.string.isRequired,
                bold: PropTypes.bool
            }),
            PropTypes.arrayOf(
                PropTypes.shape({
                    text: PropTypes.string.isRequired,
                    bold: PropTypes.bool
                })
            )
        ])
    ).isRequired
};

export default React.memo(TeamCard);
